module.exports = __webpack_public_path__ + "../resources/images/fileType_sprite-f206d80520036a5a38289af596fafb86.png";